export const NEWBUILDING_KPN_NEW_ENTERS = 'newbuilding_kpn_new_enters';
